import { render, staticRenderFns } from "./Pong.container.vue?vue&type=template&id=19323316&scoped=true&"
import script from "./Pong.container.vue?vue&type=script&lang=js&"
export * from "./Pong.container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19323316",
  null
  
)

export default component.exports